<template>
    <div>
        <button
            @click="addItem"
            class="px-4 py-2 bg-green-500 text-white rounded mb-5"
        >
            Tambah TTPK
        </button>
        <div
            v-for="(ttpk, index) in itemList"
            :key="ttpk.ttpkUniqueId || index"
            class="ttpk-entry mb-3"
        >
            <div class="lg:w-full md:w-full">
                <div class="flex items-center gap-2">
                    <Dropdown
                        class="w-full"
                        v-model="itemList[index].id"
                        :options="getOptionsForDropdown(index)"
                        optionLabel="fullname"
                        optionValue="id"
                        filter
                        filterBy="fullname"
                        @filter="(event) => fetchOptionsForDropdown(event, index, apiEndpoint)"
                        @change="() => validateUniqueness(index, 'TTPK')"
                        placeholder="Pilih Tim Teknis Pelaksanaan Kontrak"
                    />
                    <button
                        @click="removeItem(index)"
                        class="px-4 py-2 bg-red-500 text-white rounded ml-2"
                    >
                        Hapus
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent } from "vue";
import Dropdown from "primevue/dropdown";
import MultiSelectDropdownMixin from "@/mixins/MultiSelectDropdownMixin.js";

export default defineComponent({
    components: {
        Dropdown,
    },
    mixins: [MultiSelectDropdownMixin],
    props: {
        list_ttpk: Array,
        ttpk_id: String,
    },
    data() {
        // Initialize item list using mixin helper
        const ttpkInitialList = this.initializeItemList(
            this.list_ttpk,
            'ttpkUniqueId',
            'ttpkDisplayIndex'
        );
        
        return {
            // Component-specific configuration
            uniqueIdField: 'ttpkUniqueId',
            displayIndexField: 'ttpkDisplayIndex',
            apiEndpoint: '/organisasi_pengadaan/search_ttpk',
            
            // Item list management
            itemList: ttpkInitialList,
            nextIndex: this.calculateNextIndex(ttpkInitialList, 'ttpkDisplayIndex'),
        };
    },
    watch: {
        list_ttpk: {
            handler(newValue) {
                if (newValue) {
                    // Block recursive updates
                    if (this._internalUpdate) return;
                    
                    this.itemList = this.initializeItemList(
                        newValue,
                        this.uniqueIdField,
                        this.displayIndexField
                    );
                    
                    this.nextIndex = this.calculateNextIndex(this.itemList, this.displayIndexField);
                    this.updateSelectedItemsCache();
                } else {
                    this.itemList = [];
                    this.nextIndex = 1;
                    this.selectedItemsCache.clear();
                }
            },
            deep: true,
        },
        itemList: {
            handler(newValue) {
                // Prevent recursive updates
                this._internalUpdate = true;
                this.$emit("update:list_ttpk", newValue);
                this.updateSelectedItemsCache();
                this.$nextTick(() => {
                    this._internalUpdate = false;
                });
            },
            deep: true,
        },
    },
    mounted() {
        this.initializeOptions(this.apiEndpoint);
    },
});
</script>
